import { styled, Text, View, XStack, YStack } from "tamagui";

import { ChatIcon, Clock } from "../../../icons";

type HistoryItemProps = {
  isActive: boolean;
  onPress?: () => void;
  id: number;
  summaryId: number;
  name?: string | null;
  createdAt: string;
  tags?: string[] | null;
  chatSummary?: string | null;
};

const BaseTitle = styled(Text, {
  name: "BaseTitle",
  fontFamily: "$body",
  fontWeight: "$5",
  fontSize: "$3",
  lineHeight: "$3",
});

const Title: React.FC<{ children?: string; isActive?: boolean }> = ({
  children,
  isActive,
}) => {
  return (
    <XStack gap={"$1"} alignItems="center">
      <ChatIcon />
      <BaseTitle color={isActive ? "$pinkmain-500" : "$gray-secondary-400"}>
        {children}
      </BaseTitle>
    </XStack>
  );
};

const Description = styled(Text, {
  name: "Description",
  fontFamily: "$body",
  fontWeight: "$4",
  fontSize: "$3",
  lineHeight: "$3",
  color: "$gray-secondary-400",
  numberOfLines: 2,
  ellipsizeMode: "tail",
});

/**
 * @component
 * @param {Object} props - The component props.
 * @param {string} props.children - The text content of the label.
 * @param {string} props.color - The text color in hex format (e.g., `#FFFFFF`).
 */

const Label: React.FC<{
  children: string;
  color?: string;
  backgroundColor?: string;
}> = ({ children, color = "#3D86E0", backgroundColor = "#ECF3FC" }) => {
  return (
    <XStack
      borderRadius={999}
      paddingVertical={"$0.5"}
      paddingHorizontal={"$1.5"}
      alignItems="center"
      justifyContent="center"
      borderWidth={"$0.1"}
      borderColor={"$gray-100"}
      backgroundColor={backgroundColor ?? color + "66"}
      display={"inline-flex"}
    >
      <Text
        fontFamily={"$body"}
        fontWeight={"$4"}
        fontSize={"$3"}
        lineHeight={"$3"}
        color={color}
      >
        {children}
      </Text>
    </XStack>
  );
};

const MessageCount: React.FC<{ children: string }> = ({ children }) => {
  return (
    <XStack gap={"$0.5"} alignItems="center">
      <Clock />
      <Text
        fontFamily={"$subtitle"}
        fontWeight={"$4"}
        fontSize={"$2"}
        lineHeight={"$2"}
        color={"$gray-200"}
      >
        {children}
      </Text>
    </XStack>
  );
};

const formatDate = (dateString: string): string => {
  const date = new Date(dateString);
  return date.toLocaleDateString("uk-UA", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  });
};

export const HistoryItem: React.FC<HistoryItemProps> = ({
  name,
  createdAt,
  tags,
  chatSummary,
  onPress,
  isActive,
}) => {
  return (
    <View onPress={onPress} gap={"$1"} style={{ cursor: "pointer" }}>
      <YStack gap={"$0.5"}>
        <Title isActive={isActive}>{name ?? "Без назви"}</Title>
        <Description>{chatSummary}</Description>
      </YStack>
      <YStack gap={"$1"}>
        <View gap={"$1"} flexWrap={"wrap"} flexDirection={"row"}>
          {(tags?.length ?? 0) > 0 &&
            tags?.map((tag) => <Label key={tag}>{tag}</Label>)}
        </View>
        <MessageCount>{formatDate(createdAt)}</MessageCount>
      </YStack>
    </View>
  );
};

/*
do we need this one?
const SeparatorItem: React.FC<{ title: string }> = ({ title }) => {
  return (
    <XStack alignItems="center" gap={"$1"}>
      <CalendarIcon />
      <Text
        fontFamily={"$body"}
        fontWeight={"$4"}
        fontSize={"$3"}
        lineHeight={"$3"}
        color={"$gray-secondary-400"}
      >
        {title}
      </Text>
    </XStack>
  );
};
*/
